import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  microFrontEnds: [
    {
      remoteEntry: 'https://payments-panel.preprod.eshopworld.net/v2/dist/remoteEntry.js',
      remoteName: 'paymentPanel',
      exposedModule: './PaymentPanelModule',
      rel: 'paymentPanel',
      moduleId: 'default',
      type: 'script'
    }
  ],
  fraudBootstrapScriptUrl: 'https://payments-panel.preprod.eshopworld.net/js/fraudbootstrap.min.js',
  paymentsPanelApiUrl: 'https://payments-panel.preprod.eshopworld.net',
  composableApiUrl: 'https://api.preprod.esw.com',
  feroot: {
    bundleId: '#{ferootBundleId}',
    enabled: true
  },
  appInsights: '70966cc6-9a1b-4a04-8fe6-afc5c6ad475c'
};
